import { FormikProps } from "formik";
import React from "react";
import { ValidationError } from "../../api/WebApiTypes";

export default function setErrorFields<T>(formikRef: React.RefObject<FormikProps<T>>, values: Array<ValidationError>) {

    values?.forEach((err) => {
        formikRef.current?.setFieldError(err.PropertyName, err.ErrorMessage);
    })
}

